interface Options {
  /** 0-20 (inclusive) or undefined */
  minMaxFractionDigits?: number | undefined;
  currency_multiplier?: number;
  currency_code?: string;
}

// Load from server if we support more than a handful
const getCurrencyLanguage = (currency_code: string) => {
  let currency_language = 'en-CA';
  switch( currency_code  ){
    case 'USD':
      currency_language = 'en-US';
      break;
    case 'EUR':
      currency_language = 'en-GB';
      break;
    case 'AUD':
      currency_language = 'en-AU';
      break;
    case 'GBP':
      currency_language = 'en-GB';
      break;
    case 'MXN':
      currency_language = 'es-MX';
      break;
    case 'JPY':
      currency_language = 'ja-JP';
      break;
  } 
  return currency_language;
}

export const getCurrencySymbolWithCode = (currency_code: string) => {
  let currency_symbol = '';
  switch( currency_code  ){
    case 'USD':
    case 'AUD':
    case 'MXN':
      currency_symbol = `${currency_code} &dollar;`;
      break;
    case 'EUR':
      currency_symbol = `&euro; ${currency_code}`;
      break;
    case 'GBP':
      currency_symbol = `${currency_code} &pound;`;
      break;
    case 'JPY':
      currency_symbol = `&yen; ${currency_code}`;
      break;
    default:
      currency_symbol = `${currency_code}`;
      break;
  } 
  return currency_symbol;
}
export const getCurrencyFlag = (currency_code: string) => {
  let currency_flag = '';
  switch( currency_code  ){
    case 'CAD':
      currency_flag = '/styles/images/flags/icon-flag-canada.png';
      break;
    case 'USD':
      currency_flag = '/styles/images/flags/icon-flag-usa.png';
      break;
    case 'AUD':
      currency_flag = '/styles/images/flags/icon-flag-australia.png';
      break;
    case 'MXN':
      currency_flag = '/styles/images/flags/icon-flag-mexico.png';
      break;
    case 'EUR':
      currency_flag = '/styles/images/flags/icon-flag-europe.png';
      break;
    case 'GBP':
      currency_flag = '/styles/images/flags/icon-flag-greatbritain.png';
      break;
    case 'JPY':
      currency_flag = '';
      break;
  } 
  return currency_flag;
}

/** !warning: minimumFractionDigits is defaulted to 2
 *  If minimumFractionDigits is ever greator than maximumFractionDigits this function will throw
 *  Also important, maximumFractionDigits can be passed a range of 0-20 (inclusive) only otherwise it will throw
 * */
export const formatCanadianCurrency = (
  value: number | string,
   options : Options = { minMaxFractionDigits: 2 } 
): string => {
  if (options.minMaxFractionDigits !== undefined && (options.minMaxFractionDigits < 0 || options.minMaxFractionDigits > 20)) {
    throw new RangeError('minMaxFractionDigits value is out of range.');
  }
  const val_in_cents = typeof value === 'string' ? Math.round(parseFloat(value)*100) : Math.round(value*100);
  const currency_multiplier = options.currency_multiplier != undefined ? options.currency_multiplier : 1;
  const val = Number((Math.round(val_in_cents * currency_multiplier)/100).toFixed(2));
  const currency_code = options.currency_code != undefined ? options.currency_code : 'CAD';

  const currency_language = getCurrencyLanguage(currency_code);

  const formattedValue = new Intl.NumberFormat(currency_language, {
    style: 'currency',
    currency: `${currency_code}`,
    maximumFractionDigits: options.minMaxFractionDigits,
    minimumFractionDigits: options.minMaxFractionDigits,
  }).format(val);
  return formattedValue;
};
